/**
 * Vista: Catálogo de Proveedores (simplificado)
 * Solo nombre + moneda.
 */

import proveedorService from '../../services/proveedor.service.js';
import permisos from '../../services/permissions.service.js';
import router from '../../router/router.js';
import toast from '../../utils/toast.js';
import modal from '../../utils/modal.js';

let currentPage = 1;
let currentFilters = {};

export default {
  data: {
    proveedores: [],
    editingId: null
  },

  async render() {
    return `
      <div>
        <div class="card">
          <div class="card-header" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.5rem;">
            <h2 class="card-title">Proveedores</h2>
            ${permisos.canCreate('proveedores') ? `<button class="btn btn-primary" onclick="window.proveedoresView.abrirModal()">+ Nuevo Proveedor</button>` : ''}
          </div>

          <div style="display: flex; gap: var(--spacing-md); margin-bottom: var(--spacing-lg); flex-wrap: wrap;">
            <div class="form-group" style="margin: 0; flex: 1; min-width: 200px;">
              <input type="text" id="searchProv" class="form-input" placeholder="Buscar por nombre..." />
            </div>
            <div class="form-group" style="margin: 0; width: 150px;">
              <select id="monedaProvFilter" class="form-select">
                <option value="">Todas las monedas</option>
                <option value="MXN">MXN</option>
                <option value="USD">USD</option>
              </select>
            </div>
            <button class="btn btn-secondary" onclick="window.proveedoresView.resetFilters()">Limpiar</button>
          </div>

          <div id="proveedoresTable">
            <div style="text-align: center; padding: var(--spacing-xl);">Cargando...</div>
          </div>

          <div id="proveedoresPagination"></div>
        </div>

        <!-- Modal -->
        <div id="proveedorModal" class="modal-overlay" style="display: none; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); z-index: 1000; justify-content: center; align-items: center;">
          <div style="background: white; border-radius: 8px; max-width: 480px; width: 90%; padding: 1.5rem; max-height: 90vh; overflow-y: auto;">
            <h3 id="proveedorModalTitle" style="margin: 0 0 1rem;">Nuevo Proveedor</h3>

            <!-- Tipo de persona (solo creación) -->
            <div class="form-group" id="prov-group-tipo">
              <label class="form-label">Tipo de persona *</label>
              <select id="prov-tipo-persona" class="form-select">
                <option value="">Seleccionar tipo...</option>
                <option value="fisica">Física</option>
                <option value="moral">Moral</option>
              </select>
            </div>

            <!-- Nombre completo / Razón social (solo edición, readonly) -->
            <div class="form-group" id="prov-group-nombre-edit" style="display: none;">
              <label class="form-label" id="prov-label-nombre-edit">Nombre completo</label>
              <input type="text" id="prov-nombre-edit" class="form-input" readonly style="background: var(--gray-50);" />
            </div>

            <!-- Bloque física -->
            <div id="prov-bloque-fisica" style="display: none;">
              <div class="form-group">
                <label class="form-label">Nombre *</label>
                <input type="text" id="prov-nombre-fisica" class="form-input" placeholder="Juan" />
              </div>
              <div class="form-group">
                <label class="form-label">Apellido paterno *</label>
                <input type="text" id="prov-apellido-paterno" class="form-input" placeholder="Pérez" />
              </div>
              <div class="form-group">
                <label class="form-label">Apellido materno *</label>
                <input type="text" id="prov-apellido-materno" class="form-input" placeholder="García" />
              </div>
            </div>

            <!-- Bloque moral -->
            <div id="prov-bloque-moral" style="display: none;">
              <div class="form-group">
                <label class="form-label">Razón social *</label>
                <input type="text" id="prov-razon-social" class="form-input" placeholder="AgroMX S.A. de C.V." />
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">Moneda *</label>
              <select id="prov-moneda" class="form-select">
                <option value="MXN">MXN</option>
                <option value="USD">USD</option>
              </select>
            </div>

            <div style="display: flex; justify-content: flex-end; gap: 0.5rem; margin-top: 1rem;">
              <button class="btn btn-secondary" onclick="window.proveedoresView.cerrarModal()">Cancelar</button>
              <button class="btn btn-primary" onclick="window.proveedoresView.guardar()">Guardar</button>
            </div>
          </div>
        </div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('proveedores')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.proveedoresView = this;

    await this.cargar();

    document.getElementById('searchProv').addEventListener('input', (e) => {
      clearTimeout(this._t);
      this._t = setTimeout(() => {
        currentFilters.search = e.target.value;
        currentPage = 1;
        this.cargar();
      }, 400);
    });

    document.getElementById('monedaProvFilter').addEventListener('change', (e) => {
      currentFilters.moneda = e.target.value;
      currentPage = 1;
      this.cargar();
    });
  },

  async cargar() {
    const container = document.getElementById('proveedoresTable');
    try {
      const response = await proveedorService.listar({
        page: currentPage,
        limit: 20,
        ...currentFilters
      });
      const proveedores = response.data.proveedores || [];
      this.data.proveedores = proveedores;
      const pagination = response.data.pagination || {};

      if (proveedores.length === 0) {
        container.innerHTML = `<div style="text-align:center; padding: var(--spacing-xl); color: var(--gray-500);"><p>Sin proveedores.</p></div>`;
        document.getElementById('proveedoresPagination').innerHTML = '';
        return;
      }

      container.innerHTML = `
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th>Nombre</th>
              <th class="tbl-hide-mobile">Moneda</th>
              <th class="tbl-hide-mobile">Estado</th>
              <th class="tbl-hide-mobile">Acciones</th>
            </tr>
          </thead>
          <tbody>
            ${proveedores.map(p => {
              const estadoBadge = `<span class="badge ${p.activo ? 'badge-success' : 'badge-secondary'}">${p.activo ? 'Activo' : 'Inactivo'}</span>`;
              const acciones = `
                ${permisos.canEdit('proveedores') ? `<button class="btn btn-sm btn-primary" onclick="window.proveedoresView.editar(${p.id})">Editar</button>` : ''}
                ${permisos.canEdit('proveedores') ? `<button class="btn btn-sm ${p.activo ? 'btn-warning' : 'btn-success'}" onclick="window.proveedoresView.toggleActivo(${p.id})">
                  ${p.activo ? 'Desactivar' : 'Activar'}
                </button>` : ''}
                ${permisos.canDelete('proveedores') ? `<button class="btn btn-sm btn-danger" onclick="window.proveedoresView.eliminar(${p.id})">Eliminar</button>` : ''}
              `;
              return `
              <tr>
                <td>
                  <button class="tbl-expand-btn" onclick="window.proveedoresView.toggleRow(${p.id})">&#9654;</button>
                </td>
                <td><strong>${p.nombre}</strong></td>
                <td class="tbl-hide-mobile">${p.moneda}</td>
                <td class="tbl-hide-mobile">${estadoBadge}</td>
                <td class="tbl-hide-mobile">${acciones}</td>
              </tr>
              <tr class="tbl-detail-row" id="detail-prov-${p.id}">
                <td colspan="5" class="tbl-detail-cell">
                  <dl class="tbl-detail-grid">
                    <dt>Moneda</dt><dd>${p.moneda}</dd>
                    <dt>Estado</dt><dd>${estadoBadge}</dd>
                  </dl>
                  <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs); flex-wrap: wrap;">${acciones}</div>
                </td>
              </tr>
            `;
            }).join('')}
          </tbody>
        </table>
      `;

      this.renderPagination(pagination);
    } catch (error) {
      console.error(error);
      container.innerHTML = `<div style="text-align:center; padding: var(--spacing-xl); color: var(--danger);">Error al cargar proveedores</div>`;
    }
  },

  renderPagination(pagination) {
    const container = document.getElementById('proveedoresPagination');
    const { page, totalPages } = pagination;
    if (!totalPages || totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let html = '<div class="pagination">';
    html += `<button class="pagination-btn" ${page === 1 ? 'disabled' : ''} onclick="window.proveedoresView.goToPage(${page - 1})">← Anterior</button>`;
    for (let i = 1; i <= totalPages; i++) {
      html += `<button class="pagination-btn ${i === page ? 'active' : ''}" onclick="window.proveedoresView.goToPage(${i})">${i}</button>`;
    }
    html += `<button class="pagination-btn" ${page === totalPages ? 'disabled' : ''} onclick="window.proveedoresView.goToPage(${page + 1})">Siguiente →</button>`;
    html += '</div>';
    container.innerHTML = html;
  },

  goToPage(p) {
    currentPage = p;
    this.cargar();
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-prov-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  resetFilters() {
    currentFilters = {};
    currentPage = 1;
    document.getElementById('searchProv').value = '';
    document.getElementById('monedaProvFilter').value = '';
    this.cargar();
  },

  abrirModal(data = null) {
    this.data.editingId = data ? data.id : null;
    document.getElementById('proveedorModalTitle').textContent = data ? 'Editar Proveedor' : 'Nuevo Proveedor';

    const groupTipo = document.getElementById('prov-group-tipo');
    const groupNombreEdit = document.getElementById('prov-group-nombre-edit');
    const tipoSelect = document.getElementById('prov-tipo-persona');
    const bloqueFisica = document.getElementById('prov-bloque-fisica');
    const bloqueMoral = document.getElementById('prov-bloque-moral');

    // Reset
    tipoSelect.value = '';
    bloqueFisica.style.display = 'none';
    bloqueMoral.style.display = 'none';
    document.getElementById('prov-nombre-fisica').value = '';
    document.getElementById('prov-apellido-paterno').value = '';
    document.getElementById('prov-apellido-materno').value = '';
    document.getElementById('prov-razon-social').value = '';

    if (data) {
      // Edición: oculta tipo y muestra nombre readonly
      groupTipo.style.display = 'none';
      groupNombreEdit.style.display = '';
      document.getElementById('prov-nombre-edit').value = data.nombre || '';
      document.getElementById('prov-label-nombre-edit').textContent =
        data.tipo_persona === 'moral' ? 'Razón social' : 'Nombre completo';
      document.getElementById('prov-moneda').value = data.moneda || 'MXN';
    } else {
      // Creación
      groupTipo.style.display = '';
      groupNombreEdit.style.display = 'none';
      document.getElementById('prov-moneda').value = 'MXN';
    }

    // Listener para alternar bloques según tipo
    tipoSelect.onchange = () => {
      const tipo = tipoSelect.value;
      bloqueFisica.style.display = tipo === 'fisica' ? 'block' : 'none';
      bloqueMoral.style.display = tipo === 'moral' ? 'block' : 'none';
    };

    document.getElementById('proveedorModal').style.display = 'flex';
  },

  cerrarModal() {
    document.getElementById('proveedorModal').style.display = 'none';
    this.data.editingId = null;
  },

  async guardar() {
    const moneda = document.getElementById('prov-moneda').value;
    if (!moneda) {
      toast.error('La moneda es requerida');
      return;
    }

    try {
      if (this.data.editingId) {
        // Solo actualiza moneda (nombre/tipo no se editan aquí)
        await proveedorService.actualizar(this.data.editingId, { moneda });
        toast.success('Proveedor actualizado');
        this.cerrarModal();
        await this.cargar();
        return;
      }

      const tipo = document.getElementById('prov-tipo-persona').value;
      if (!tipo) {
        toast.error('El tipo de persona es requerido');
        return;
      }
      const payload = { moneda, tipo_persona: tipo };
      if (tipo === 'fisica') {
        payload.nombre = document.getElementById('prov-nombre-fisica').value.trim();
        payload.apellido_paterno = document.getElementById('prov-apellido-paterno').value.trim();
        payload.apellido_materno = document.getElementById('prov-apellido-materno').value.trim();
        if (!payload.nombre) { toast.error('El nombre es requerido'); return; }
        if (!payload.apellido_paterno) { toast.error('El apellido paterno es requerido'); return; }
        if (!payload.apellido_materno) { toast.error('El apellido materno es requerido'); return; }
      } else {
        payload.razon_social = document.getElementById('prov-razon-social').value.trim();
        if (!payload.razon_social) { toast.error('La razón social es requerida'); return; }
      }

      await proveedorService.crear(payload);
      toast.success('Proveedor creado');
      this.cerrarModal();
      await this.cargar();
    } catch (error) {
      if (error.status === 409) {
        modal.open(
          'Proveedor duplicado',
          `<p style="margin: 0;">${error.message || 'Ese nombre ya está en uso.'}</p>`,
          [{ text: 'Entendido', class: 'btn-primary' }]
        );
      } else {
        toast.error(error.message || 'Error al guardar');
      }
    }
  },

  _mostrarModalDuplicado(details, esEdicion = false) {
    const camposStr = (details.campos_coincidentes || []).join(' y ');
    const titulo = esEdicion ? 'No se puede actualizar el proveedor' : 'No se puede crear el proveedor';

    const renderFieldHighlight = (label, value, matched) => {
      if (!value) return '';
      const style = matched
        ? 'background: #fff3cd; padding: 0.1rem 0.35rem; border-radius: 3px; color: #856404; font-weight: 600;'
        : '';
      const badge = matched ? ' <span style="font-size: 0.7rem; color: #856404;">← coincide</span>' : '';
      return `<div><strong>${label}:</strong> <span style="${style}">${value}</span>${badge}</div>`;
    };

    const filas = details.duplicados.map(d => {
      const matched = d.campos_que_coincidieron || [];
      return `
        <div style="border: 1px solid var(--gray-300); border-radius: 6px; padding: 0.75rem; margin-bottom: 0.5rem; background: var(--gray-50);">
          ${renderFieldHighlight('Nombre', d.nombre_completo, matched.includes('nombre'))}
          <div style="font-size: 0.85rem; color: var(--text-muted); margin-top: 0.3rem;">
            ${renderFieldHighlight('Email', d.email, matched.includes('email'))}
            ${renderFieldHighlight('Teléfono', d.telefono, matched.includes('teléfono'))}
          </div>
        </div>
      `;
    }).join('');

    modal.open(
      titulo,
      `
        <div style="background: #fff3cd; color: #856404; padding: 0.75rem 1rem; border-radius: 6px; margin-bottom: 1rem; border-left: 3px solid #f0ad4e;">
          Ya existe una persona con <strong>${camposStr}</strong> coincidente.
        </div>
        ${filas}
        <p style="margin-top: 1rem; font-size: 0.85rem; color: var(--text-muted);">
          Los campos resaltados son los que coinciden. Si crees que es otra persona diferente, ajusta los datos para diferenciarla.
        </p>
      `,
      [{ text: 'Entendido', class: 'btn-primary' }]
    );
  },

  async editar(id) {
    try {
      const response = await proveedorService.obtenerPorId(id);
      this.abrirModal(response.data.proveedor);
    } catch (error) {
      toast.error('Error al cargar proveedor');
    }
  },

  async toggleActivo(id) {
    const proveedor = this.data.proveedores.find(p => p.id === id);
    const nombre = proveedor?.nombre || 'este proveedor';
    const accion = proveedor?.activo ? 'desactivar' : 'activar';
    modal.confirm(
      'Cambiar estado del proveedor',
      `¿Está seguro de ${accion} a <strong>${nombre}</strong>?`,
      async () => {
        try {
          await proveedorService.toggleActivo(id);
          toast.success('Estado actualizado');
          await this.cargar();
        } catch (error) {
          toast.error(error.message || 'Error al cambiar estado');
        }
      }
    );
  },

  async eliminar(id) {
    const proveedor = this.data.proveedores.find(p => p.id === id);
    const nombre = proveedor?.nombre || 'este proveedor';
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar a <strong>${nombre}</strong>? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await proveedorService.eliminar(id);
          toast.success('Proveedor eliminado');
          await this.cargar();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar');
        }
      }
    );
  }
};
